import React from 'react'
import Login from './pages/Login'
import Error from './pages/Error'
import SignUp from './pages/SignUp'
import ResetPassword from './pages/ResetPassword'
import AboutUs from './pages/AboutUs'
import ComingSoon from './pages/ComingSoon'
import Maintenance from './pages/Maintenance'
import LockScreen from './pages/LockScreen'
import Support from './pages/Support'
import OverView from './pages/Overview'
import Guides from './pages/Guides'
import Faqs from './pages/Faqs'
import BlogDetail from './pages/BlogDetail'
import Blog from './pages/Blog'
import Contact from './pages/Contact'
import UploadWork from './pages/UploadWork'
import Collections from './pages/Collections'
import {BrowserRouter, Route, Routes} from 'react-router-dom'
import BecomeCreator from './pages/BecomeCreator'
import CreateProfile from './pages/CreatorProfile'
import Creator from './pages/Creator'
import Wallet from './pages/Walllet'
import Activity from './pages/Activity'
import ItemDetailOne from './pages/ItemDetailOne'
import ItemDetailTwo from './pages/ItemDetailTwo'
import Auction from './pages/Auction'
import ExploreFour from './pages/ExploreFour'
import ExploreThree from './pages/ExploreThree'
import ExploreTwo from './pages/ExploreTwo'
import DarkVersionOne from './pages/DarkVersionOne'
import DarkVersionTwo from './pages/DarkVersionTwo'
import DarkVersionFive from './pages/DarkVersionFive'
import DarkVersionThree from './pages/DarkVersionThree'
import DarkVersionFour from './pages/DarkVersionFour'
import BlogSidebar from './pages/BlogSidebar'
import ExploreOne from './pages/ExploreOne'
import CreatorProfileEdit from './pages/CreatorProfileEdit'
import Terms from './pages/Terms'
import Privacy from './pages/Privacy'
import ChangeLog from './pages/ChangeLog'

export default function Router() {
  return (
    <BrowserRouter>
      <Routes>
   
        {/* auth router  */}
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<SignUp />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/lock-screen" element={<LockScreen />} />

        {/* special router page  */}
        <Route path="/error" element={<Error />} />
        <Route path="/comingsoon" element={<ComingSoon />} />
        <Route path="/maintenance" element={<Maintenance />} />

        {/* help center routes */}
        <Route path="/helpcenter-support-request" element={<Support />} />
        <Route path="/helpcenter-overview" element={<OverView />} />
        <Route path="/helpcenter-guides" element={<Guides />} />
        <Route path="/helpcenter-faqs" element={<Faqs />} />

        {/* template page routes  */}
        <Route path="/blog-detail" element={<BlogDetail />} />
        <Route path="/aboutus" element={<AboutUs />} />
        <Route path="/blogs" element={<Blog />} />
        <Route path="/blog-sidebar" element={<BlogSidebar />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/upload-work" element={<UploadWork />} />
        <Route path="/collections" element={<Collections />} />
        <Route path="/become-creator" element={<BecomeCreator />} />
        <Route path="/creator-profile" element={<CreateProfile />} />
        <Route
          path="/creator-profile-edit"
          element={<CreatorProfileEdit />}
        />
        <Route path="/creators" element={<Creator />} />
        <Route path="/wallet" element={<Wallet />} />
        <Route path="/activity" element={<Activity />} />
        <Route path="/item-detail-one" element={<ItemDetailOne />} />
        <Route path="/item-detail-two" element={<ItemDetailTwo />} />
        <Route path="/auction" element={<Auction />} />
        <Route path="/explore-four" element={<ExploreFour />} />
        <Route path="/explore-three" element={<ExploreThree />} />
        <Route path="/explore-two" element={<ExploreTwo />} />
        <Route path="/explore-one" element={<ExploreOne />} />

        <Route path="/index-dark" element={<DarkVersionOne />} />
        <Route path="/index-dark-rtl" element={<DarkVersionOne />} />
        <Route path="/index" element={<DarkVersionOne />} />
        <Route path="/" element={<DarkVersionOne />} />
        <Route path="/index-rtl" element={<DarkVersionOne />} />

        <Route path="/index-two-dark" element={<DarkVersionTwo />} />
        <Route path="/index-two-dark-rtl" element={<DarkVersionTwo />} />
        <Route path="/index-two" element={<DarkVersionTwo />} />
        <Route path="/index-two-rtl" element={<DarkVersionTwo />} />

        <Route path="/index-three-dark" element={<DarkVersionThree />} />
        <Route
          path="/index-three-dark-rtl"
          element={<DarkVersionThree />}
        />
        <Route path="/index-three" element={<DarkVersionThree />} />
        <Route path="/index-three-rtl" element={<DarkVersionThree />} />

        <Route path="/index-four-dark" element={<DarkVersionFour />} />
        <Route
          path="/index-four-dark-rtl"
          element={<DarkVersionFour />}
        />
        <Route path="/index-four" element={<DarkVersionFour />} />
        <Route path="/index-four-rtl" element={<DarkVersionFour />} />

        <Route path="/index-five-dark" element={<DarkVersionFive />} />
        <Route
          path="/index-five-dark-rtl"
          element={<DarkVersionFive />}
        />
        <Route path="/index-five" element={<DarkVersionFive />} />
        <Route path="/index-five-rtl" element={<DarkVersionFive />} />

        <Route path="/terms" element={<Terms />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/changelog" element={<ChangeLog />} />
      </Routes>
    </BrowserRouter>
  )
}
